import { getSingleAgeRangeValue } from 'components/date/AgeRange'
import { FaixaEtariaEnum } from 'graphql/types.generated'
import { createValidator, empty, ErrorObject, range, required } from 'util/validation'

import {
  AcompanhamentoCondicaoSaudeFormModel,
  TipoVulnerabilidadeEnum,
} from './model/model-acompanhamentoCondicaoSaude'

const validateCommonFilters = (
  values: AcompanhamentoCondicaoSaudeFormModel,
  errors: ErrorObject<AcompanhamentoCondicaoSaudeFormModel>
) => {
  const { faixaEtariaRange, tipoFaixaEtaria } = values

  if (FaixaEtariaEnum.OUTRA === tipoFaixaEtaria && !errors.faixaEtariaRange) {
    errors.faixaEtariaRange = required(getSingleAgeRangeValue(faixaEtariaRange))
  }
}

export const validate = createValidator<AcompanhamentoCondicaoSaudeFormModel>(
  {
    equipeResponsavel: required,
  },
  (values: AcompanhamentoCondicaoSaudeFormModel, errors: ErrorObject<AcompanhamentoCondicaoSaudeFormModel>) => {
    const { tipoVulnerabilidadeSelected, tria } = values
    validateCommonFilters(values, errors)

    if (tipoVulnerabilidadeSelected === TipoVulnerabilidadeEnum.TRIA) {
      errors.tria = {
        periodoRegistro: required(tria?.periodoRegistro),
        resultadosTria: required(tria?.resultadosTria),
      }
    }

    return errors
  }
)

export const validateFiltrosAvancados = createValidator<AcompanhamentoCondicaoSaudeFormModel>(
  {},
  (values: AcompanhamentoCondicaoSaudeFormModel, errors: ErrorObject<AcompanhamentoCondicaoSaudeFormModel>) => {
    validateCommonFilters(values, errors)

    if (values.ivcf?.exibirApenasCidadaosIdososSemIvcf) {
      errors.ivcf = {
        pontuacao: empty(values.ivcf?.pontuacao),
        riscoVulnerabilidade: empty(values.ivcf?.riscoVulnerabilidade),
        subgrupo: empty(values.ivcf?.subgrupo),
      }
    } else {
      errors.ivcf = {
        pontuacao:
          range(0, 40)(values.ivcf?.pontuacao?.firstValue) || range(0, 40)(values.ivcf?.pontuacao?.secondValue),
      }

      return errors
    }
  }
)
